import createVueApp from '../create-app'
import { App as Apps } from '@/common/constant'
import App from './App.vue'

createVueApp(App, Apps.Account)
